module.exports = __webpack_public_path__ + "media/src/img/payment/heart-orange-b72907c6c53206705b92aa17688a8021.svg";